import React from 'react';
import { Leaf, Instagram, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Leaf className="text-primary-400 h-8 w-8" />
            <span className="text-2xl font-bold tracking-tight">Alaiaathi</span>
          </div>
          <p className="text-primary-100/80 leading-relaxed">
            Bringing you the purest, natural products from our fields to your home. Sustainably sourced and organically grown.
          </p>
          <div className="flex space-x-4">
            <a href="/" className="hover:text-primary-400 transition-colors"><Instagram className="h-6 w-6" /></a>
            <a href="/" className="hover:text-primary-400 transition-colors"><Facebook className="h-6 w-6" /></a>
            <a href="/" className="hover:text-primary-400 transition-colors"><Twitter className="h-6 w-6" /></a>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-bold mb-6">Quick Links</h3>
          <ul className="space-y-4 text-primary-100/80">
            <li><a href="/" className="hover:text-white transition-colors">Home</a></li>
            <li><a href="/shop" className="hover:text-white transition-colors">Shop All</a></li>
            <li><a href="/about" className="hover:text-white transition-colors">Our Story</a></li>
            <li><a href="/blog" className="hover:text-white transition-colors">Natural Living</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold mb-6">Support</h3>
          <ul className="space-y-4 text-primary-100/80">
            <li><a href="/contact" className="hover:text-white transition-colors">Contact Us</a></li>
            <li><a href="/shipping" className="hover:text-white transition-colors">Shipping Info</a></li>
            <li><a href="/returns" className="hover:text-white transition-colors">Returns & Exchanges</a></li>
            <li><a href="/faq" className="hover:text-white transition-colors">FAQs</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold mb-6">Join Our Newsletter</h3>
          <p className="text-primary-100/80 mb-4">Get updates on new products and special offers.</p>
          <div className="flex">
            <input
              type="email"
              placeholder="Email address"
              className="bg-primary-800 border-none rounded-l-lg py-2 px-4 w-full focus:ring-1 focus:ring-primary-400 outline-none"
            />
            <button className="bg-primary-500 hover:bg-primary-400 px-4 py-2 rounded-r-lg transition-colors">
              Join
            </button>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mt-16 pt-8 border-t border-primary-800 text-center text-primary-100/60 text-sm">
        &copy; {new Date().getFullYear()} Alaiaathi. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
